import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import {  useLocation, useNavigate } from 'react-router-dom';
import { ContextData } from '../../context/Context'
import BadgeMax from '../Section/pages/BadgeMax';
import baseUrl from "../../BaseURL";
import axios from 'axios';


export default function Nav() {

      const Navigate = useNavigate();
      const UseLocation = useLocation()
      const {Person,accesstoken,Refresh} = React.useContext(ContextData)
      const [StudentData,setStudentData] = React.useState()
    

      const [pendingUpdates,setPendingUpdates] = React.useState(0);
      React.useEffect(()=>{
        if(!['100','90'].includes(String(Person?.acc_level)))return;
        const controller=new AbortController();
        async function refreshUpdates(){try{const {data}=await axios.get(`${baseUrl}/auth/member-updates/summary`,{signal:controller.signal,withCredentials:true,headers:{authorization:`Bearer ${accesstoken}`},timeout:15000});if(!controller.signal.aborted)setPendingUpdates(Number(data.pending)||0);}catch{}}
        void refreshUpdates();const timer=setInterval(refreshUpdates,30000);
        return ()=>{controller.abort();clearInterval(timer);};
      },[Refresh,accesstoken,Person?.acc_level]);
        React.useEffect(()=>{


          async function FetchData(){
          try {
            const response = await axios.get(`${baseUrl}/auth/get_member_datas_for_all?summary=1`,{
              withCredentials: true,
              headers: { 
                'Accept' : 'application/json',
                'authorization': `Bearer ${accesstoken !== null && accesstoken}`
              }}) 
            setStudentData(response.data)
                 
          } catch (err) {
             if(err) console.log(err.message)
          }
    }FetchData()

        },[Refresh])

        
      const countVfy = Number(StudentData?.verification || 0);
      const countApprove = Number(StudentData?.approval || 0);
      const countPending = Number(StudentData?.pending || 0);
      const countPendingIDCard = Number(StudentData?.cards || 0);


      const isActive = (pathName) =>{
        return UseLocation.pathname === pathName    
      }



  return (
    <div className='navList dashboard-nav'>
      <Button onClick={()=>Navigate('/dashboard/profile')} aria-current={isActive('/dashboard/profile')?'page':undefined} variant="contained">My profile</Button>
      {['100','90'].includes(String(Person?.acc_level)) && <Button onClick={()=>Navigate('/dashboard/updates')} aria-current={isActive('/dashboard/updates')?'page':undefined} variant="contained">Updates {pendingUpdates>0&&<span aria-label={`${pendingUpdates} updates awaiting approval`} style={{marginLeft:8,background:'#f6c85f',color:'#173e2e',borderRadius:12,padding:'2px 7px',fontWeight:800}}>{pendingUpdates}</span>}</Button>}
      {String(Person?.acc_level)==='100' && <Button onClick={()=>Navigate('/dashboard/transactions')} aria-current={isActive('/dashboard/transactions')?'page':undefined} variant="contained">Transactions</Button>}

     
   
           {
          Person !== null && 
          
          <>
           {
            Person.acc_level === "100" &&
             <>
            <Button style={{background:isActive("/dashboard/statistics") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/statistics")} aria-current={isActive("/dashboard/statistics") ? "page" : undefined} variant="contained">Statistics</Button>
           <Button style={{background:isActive("/dashboard/payment") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/payment")} aria-current={isActive("/dashboard/payment") ? "page" : undefined} variant="contained">Set Payment</Button>
          
    
          <Button 
           onClick={() => Navigate("/dashboard/adminusers")} aria-current={isActive("/dashboard/adminusers") ? "page" : undefined}
           style={{background:isActive("/dashboard/adminusers") && "rgba(36, 4, 49, 0.9)" }}
           variant="contained"
           >Admin Users</Button>
          <Button style={{background:isActive("/dashboard/user") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/user")} aria-current={isActive("/dashboard/user") ? "page" : undefined} variant="contained">Users</Button>
          
             </>
           }

           {
             Person.acc_level === "100" &&
             <> 

              <Button style={{background:isActive("/dashboard/commission") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/commission")} aria-current={isActive("/dashboard/commission") ? "page" : undefined} variant="contained"> Set Commission
             </Button> 
             <Button style={{background:isActive("/dashboard/pay") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/pay")} aria-current={isActive("/dashboard/pay") ? "page" : undefined} variant="contained"> Pay
             </Button> 

             <Button style={{background:isActive("/dashboard/members") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/members")} aria-current={isActive("/dashboard/members") ? "page" : undefined} variant="contained">Members</Button>
             <Button style={{background:isActive("/dashboard/verification") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/verification")} aria-current={isActive("/dashboard/verification") ? "page" : undefined} variant="contained">
             <span className='absolute z-10 top-0 '> <BadgeMax value={countVfy}  /></span>
             Verification</Button> 
             <Button style={{background:isActive("/dashboard/approve") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/approve")} aria-current={isActive("/dashboard/approve") ? "page" : undefined} variant="contained">Approve
             <span className='absolute z-10 top-0 '> <BadgeMax value={countApprove}  /></span>
             </Button> 

             <Button style={{background:isActive("/dashboard/pending") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/pending")} aria-current={isActive("/dashboard/pending") ? "page" : undefined} variant="contained">Pending
             <span className='absolute z-10 top-0 '> <BadgeMax value={countPending}  /></span>
             </Button> 

             <Button style={{background:isActive("/dashboard/id_card") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/id_card")} aria-current={isActive("/dashboard/id_card") ? "page" : undefined} variant="contained">ID-Card
             <span className='absolute z-10 top-0 '> <BadgeMax value={countPendingIDCard}  /></span>
             </Button> 

               <Button style={{background:isActive("/dashboard/id_card") && "rgba(36, 4, 49, 0.9)",marginBottom:"1em" }} onClick={() => Navigate("/dashboard/prentable_disc")} aria-current={isActive("/dashboard/prentable_disc") ? "page" : undefined} variant="contained">Printable cards
             <span className='absolute z-10 top-0 '> <BadgeMax value={countPendingIDCard}  /></span>
             </Button> 

            
            

             </>
           }

           {/* Manage */}

            {
             Person.acc_level === "90" &&
             <> 

             <Button style={{background:isActive("/dashboard/members") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/members")} aria-current={isActive("/dashboard/members") ? "page" : undefined} variant="contained">Members</Button>
             <Button style={{background:isActive("/dashboard/verification") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/verification")} aria-current={isActive("/dashboard/verification") ? "page" : undefined} variant="contained">
             <span className='absolute z-10 top-0 '> <BadgeMax value={countVfy}  /></span>
             Verification</Button> 
             <Button style={{background:isActive("/dashboard/approve") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/approve")} aria-current={isActive("/dashboard/approve") ? "page" : undefined} variant="contained">Approve
             <span className='absolute z-10 top-0 '> <BadgeMax value={countApprove}  /></span>
             </Button> 

             <Button style={{background:isActive("/dashboard/pending") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/pending")} aria-current={isActive("/dashboard/pending") ? "page" : undefined} variant="contained">Pending
             <span className='absolute z-10 top-0 '> <BadgeMax value={countPending}  /></span>
             </Button> 

            {/*  <Button style={{background:isActive("/dashboard/id_card") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/id_card")} aria-current={isActive("/dashboard/id_card") ? "page" : undefined} variant="contained">ID-Card
             <span className='absolute z-10 top-0 '> <BadgeMax value={countPendingIDCard}  /></span>
             </Button>  */}

                <Button style={{background:isActive("/dashboard/id_card") && "rgba(36, 4, 49, 0.9)",marginBottom:"1em" }} onClick={() => Navigate("/dashboard/prentable_disc")} aria-current={isActive("/dashboard/prentable_disc") ? "page" : undefined} variant="contained">Printable cards
             <span className='absolute z-10 top-0 '> <BadgeMax value={countPendingIDCard}  /></span>
             </Button> 

             </>
           }

            {
             Person.acc_level === "0" &&
              <> 
             <Button style={{background:isActive("/dashboard/members") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/members")} aria-current={isActive("/dashboard/members") ? "page" : undefined} variant="contained">Members</Button>
            {Person.usertype === 'user' && <Button onClick={() => Navigate('/dashboard/purchase-history')} aria-current={isActive('/dashboard/purchase-history') ? 'page' : undefined} variant="contained">Purchase history</Button>}
            {/*  <Button style={{background:isActive("/dashboard/deposite") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/payment")} aria-current={isActive("/dashboard/payment") ? "page" : undefined} variant="contained">Deposit</Button> */}
             
             </>
            }
         
          </>
            }


             {
            Person !== null && <>   
             {
              Person.usertype === "ID-Card-User" &&
               <> 
               <Button style={{background:isActive("/dashboard/statistics") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/statistics")} aria-current={isActive("/dashboard/statistics") ? "page" : undefined} variant="contained">Statistics</Button>
              </>
             }</>
            }

            {   /* Finance Department */ }
            {
            Person !== null && <>   
             {
              Person.usertype === "Finance Manager" &&
               <> 
               <Button style={{background:isActive("/dashboard/statistics") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/statistics")} aria-current={isActive("/dashboard/statistics") ? "page" : undefined} variant="contained">Statistics</Button>
              </>
             }</>
            }


            {/* Reviewer  analyzer */}

            {
            Person !== null && <>   
             {
              Person.usertype === "Finance Manager" &&
               <> 
               <Button style={{background:isActive("/dashboard/statistics") && "rgba(36, 4, 49, 0.9)" }} onClick={() => Navigate("/dashboard/statistics")} aria-current={isActive("/dashboard/statistics") ? "page" : undefined} variant="contained">Analytics</Button>
              </>
             }</>
            }

    </div>
  );
}